// if(window.innerWidth >= 1250){
//   var elem = document.querySelector('.desktop-slider-1');
//   var flkty = new Flickity( elem, {
//     // options
//     on: {
//     ready: function() {
//       document.querySelector('#first .section.feature-tab').classList.add("f-active");
//     }
//   },
//     cellAlign: 'left',
//     groupCells: true,
//     wrapAround: false,
//     cellSelector: '.one-third',
//     contain: true
//   });
//   var elem = document.querySelector('.desktop-slider-2');
//   var flkty = new Flickity( elem, {
//     // options
//     on: {
//       ready: function() {
//         document.querySelector('#second .section.feature-tab').classList.add("f-active");
//       }
//     },
//     cellAlign: 'left',
//     groupCells: true,
//     wrapAround: false,
//     cellSelector: '.one-third',
//     contain: true
//   });
//   }

if(window.innerWidth <= 1100){
  document.getElementById("mobile_search").addEventListener("click", function(e) {
    e.preventDefault();
    const search_input = document.querySelector('#bc-sf-search-box-mobile');
    document.body.classList.add("search-active");
    document.getElementsByClassName("bc-sf-search-suggestion-mobile-top-panel")[0].style.display = "block";
    if(search_input){
      search_input.focus();
    }
  });

  document.getElementById("search_close").addEventListener("click", function() {
    document.body.classList.remove("search-active");
  });

  setTimeout(function() {
  document.getElementsByClassName("bc-sf-search-btn-close-suggestion")[0]?.addEventListener("click", function() {
    document.body.classList.remove("search-active");
  });
}, 5000);
}

// // show search dropdown on input focus
//   var input = document.getElementById("bc-sf-search-box-1");
//   document.getElementById("bc-sf-search-box-1").addEventListener("focus", function() {
//     if (input.value.length > 0) {
//     document.getElementById("ui-id-2").style.display = "block";
//   }
//   });




document.addEventListener('DOMContentLoaded', () => {

  // Search query parameter truncate issue fix start
  // Function to handle search input and mitigate query truncation issues
  function handleSearchLatency() {
    const searchInputs = document.querySelectorAll('.bc-sf-search-box');
    
    // Loop through each input and add an event listener for the 'keydown' event
    searchInputs.forEach(input => {
        input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();

                // Get the current value of the search input and trim any whitespace
                const searchInput = event.target;
                const query = searchInput.value.trim();
                // If the query is not empty, redirect to the search URL with the query parameter
                if (query) {
                  setTimeout(() => {
                    window.location.href = `/search?type=product&q=${encodeURIComponent(query)}`;
                  }, 0);
                }
            }
        });
    });
  }
  handleSearchLatency();
  // Search query parameter truncate issue fix end

  // Search page suggestion box position start
  // Debounce function to limit the rate of function execution
  function searchBoxPositionDebounce(func, delay) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }
  // Function to find the appropriate suggestion wrapper
  function findVisibleSuggestionWrapper() {
    // Select all suggestion wrappers
    const suggestionWrappers = document.querySelectorAll('.bc-sf-search-suggestion-wrapper');

    suggestionWrappers.forEach(wrapper => {
        const ulElement = wrapper.querySelector('ul');
        // Check if the ul element exists and is not set to display: none
        if (ulElement && getComputedStyle(ulElement).display !== 'none') {
            wrapper.style.setProperty('position', 'absolute', 'important');
        }
    });
  }

  // Event listeners for search input fields inside search_page
  const searchInputs = document.querySelectorAll('.search_page input.bc-sf-search-box');
  searchInputs.forEach(input => {
    input.addEventListener('focus', searchBoxPositionDebounce(() => {
        findVisibleSuggestionWrapper();
    }, 300));
  });
  // Search page suggestion box position end

  
  // script to handle search default UI bug start 
  // Function to handle the z-index when clicking inside or outside the search bar
  function handleSearchFocus() {
    const searchWrapper = document.querySelector('.bc-sf-search-suggestion-wrapper');
    const searchSuggestion = searchWrapper.querySelector('.bc-sf-search-suggestion');
    const searchInputs = document.querySelectorAll('.bc-sf-search-box'); // Select both mobile and desktop search inputs
    
    function hideSuggestionWrapper() {
      if (searchWrapper) {
        searchWrapper.classList.add('hideSuggestion');
      }
    }
    
    function showSuggestionWrapper() {
      if (searchWrapper) {
        searchWrapper.classList.remove('hideSuggestion');
      }
    }
    
    searchInputs.forEach(inputField => {
      inputField.addEventListener('focus', () => {
        showSuggestionWrapper();
      });
      inputField.addEventListener('blur', () => {
        hideSuggestionWrapper();
      });
    });
  }
   // Function to handle the instagram carousel ADA changes.
   function handleInstagramCarouselSection(node) {
    const yImageWrappers = node.querySelectorAll('.y-image-wrapper');
    yImageWrappers.forEach((wrapper) => {
      wrapper.removeAttribute('role');
    });
  }
  
  // Set up the MutationObserver to monitor changes to the body (or another container element)
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        // Check for the search wrapper
        if (node.classList && node.classList.contains('bc-sf-search-suggestion-wrapper')) {
          handleSearchFocus();
        }

        // code below handles the instagram carousel section.
        if (node.nodeType === 1 && node.classList.contains('yotpo-slider-wrapper')) {
          handleInstagramCarouselSection(node);
        }
      });
    });
  });
  // Start observing the body for changes (can change 'body' to another specific container if needed)
  observer.observe(document.body, {
      childList: true,
      subtree: true,
  });
  // script to handle search default UI bug end
 
});